import React from "react";
import {
  HomeContainer,
  HomeBackground,
  HomeTitle,
  SectionsContainer,
  LinkContainer,
} from "./HomeElements";

const LanguageMenu = ({ setLanguage }) => {
  return (
    <HomeContainer>
      <HomeBackground />
      <HomeTitle>Seleccione Idioma / Select Language</HomeTitle>
      <SectionsContainer>
        <LinkContainer
          as="button"
          onClick={() => setLanguage("es")}
          style={{
            cursor: "pointer"
          }}
        >
          <h2 style={{
            color: "white",
            fontSize: "1.75rem",
            textTransform: "uppercase",
            letterSpacing: "1.5px",
            lineHeight: "40px",
            fontWeight: "normal",}}>Español</h2>
        </LinkContainer>
        <LinkContainer
          as="button"
          onClick={() => setLanguage("en")}
          style={{
            cursor: "pointer"
          }}
        >
          <h2 style={{
            color: "white",
            fontSize: "1.75rem",
            textTransform: "uppercase",
            letterSpacing: "1.5px",
            lineHeight: "40px",
            fontWeight: "normal",
          }}>English</h2>
        </LinkContainer>
      </SectionsContainer>
    </HomeContainer>
  );
};

export default LanguageMenu;